import { StyleSheet } from "react-native";
import { theme } from "../../../theme/theme";
const style = () => {
    const { colorTextError } = theme();
    return StyleSheet.create({
        error: {
            color: colorTextError,
        },
    });
};
export { style };
